import { useMediaQuery } from "../utils/useMediaQuery";

export function MetaData({ disciplines, shortDisciplines, year, project }) {
  const hideYear = useMediaQuery("(min-width: 600px) and (max-width: 960px)");
  const shortenDisciplines = useMediaQuery(
    "(min-width: 600px) and (max-width: 710px)"
  );
  return (
    <div className="meta-data grid-twelve-cols-lg grid-four-cols-sm span-twelve-lg span-four-sm">
      <div
        className={
          hideYear
            ? "meta-item start-one-lg span-four-lg span-five-md no-wrap-text"
            : "meta-item start-one-lg span-four-lg start-two-sm span-three-sm no-wrap-text"
        }
      >
        <p className="meta-title">Disciplines</p>
        <p className="meta-description no-wrap-text">
          {shortenDisciplines && shortDisciplines
            ? shortDisciplines
            : disciplines}
        </p>
      </div>
      {!hideYear && (
        <div className="meta-item start-five-lg span-one-lg start-one-sm span-one-sm">
          <p className="meta-title">Year</p>
          <p className="meta-description">{year}</p>
        </div>
      )}
      <div className="meta-item start-six-lg span-seven-lg start-two-sm span-two-sm">
        <p className="meta-title">Project</p>
        <p className="meta-description">
          {shortenDisciplines
            ? project.startsWith("The ")
              ? project.slice(4)
              : project
            : project}
        </p>
      </div>
    </div>
  );
}
